import { createSlice } from '@reduxjs/toolkit';
import {
  closeLixaniPaintDialog,
  openLixaniPaintDialog,
  setLixaniPaintImage,
} from '../actions/lixani-paint.actions';

export const lixaniPaintSlice = createSlice({
  name: 'lixaniPaint',
  initialState: {
    isLixaniPaintDialogOpen: false,
    currentImageUrl: null,
    imageMetadata: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(openLixaniPaintDialog, (state) => {
        state.isLixaniPaintDialogOpen = true;
      })
      .addCase(closeLixaniPaintDialog, (state) => {
        state.isLixaniPaintDialogOpen = false;
        state.currentImageUrl = null;
        state.imageMetadata = null;
      })
      .addCase(setLixaniPaintImage, (state, action) => {
        state.currentImageUrl = action.payload.imageUrl;
        state.imageMetadata = action.payload.metadata;
      });
  },
});
